import React from "react";
import PageCarousel from "../components/PageCarousel";

class PreviousConferences extends React.Component {
  componentDidMount() {
    document.title =
      "Previous Conferences : Conference on Artificial Intelligence and Education";
  }
  render() {
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col-lg-9">
                <div className="col text-center">
                  <div className="section_title_container text-center">
                    <div className="contact_title">
                      <h1> Previous Converences</h1>
                    </div>
                  </div>
                  <div className="intro_left_content text_left">
                    <h4>
                      This conference was held as a special track for the past 5
                      years:
                    </h4>

                    <div align="left">
                      <div>
                        <b>Conference Tracks</b>
                      </div>

                      <ul style={{ listStyleType: "circle" }} align="left">
                        <li>
                          {" "}
                          <a
                            href="https://www.icita.world/aaie/2025"
                            target="_blank"
                          >
                            Education & Educational Technologies 2025
                          </a>
                        </li>
                        <li>
                          {" "}
                          <a
                            href="https://www.icita.world/aaie/2024"
                            target="_blank"
                          >
                            Education & Educational Technologies 2024
                          </a>
                        </li>
                        <li>
                          {" "}
                          <a
                            href="https://www.icita.world/aaie/2023"
                            target="_blank"
                          >
                            Education & Educational Technologies 2023
                          </a>
                        </li>
                        <li>
                          {" "}
                          <a
                            href="https://www.icita.world/aaie/2022"
                            target="_blank"
                          >
                            Education & Educational Technologies 2022
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.icita.world/aaie/2021"
                            target="_blank"
                          >
                            Education & Educational Technologies 2021
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PreviousConferences;
